/**
 * 指定月・対象スタッフのシフトを一括生成する（Edge Function 経由）。
 * 生成処理自体はサーバ側。usecase は gateway を呼ぶ薄い層だが、
 * 将来のバリデーション/スコープ判定の差し込み口となる。
 */
import type { ShiftDeps } from "./deps";

export interface BulkGenerateShiftsInput {
  yearMonth: string;
  staffIds: string[];
}

export async function bulkGenerateShifts(
  input: BulkGenerateShiftsInput,
  deps: ShiftDeps,
): Promise<{ generated: number }> {
  return deps.gateway.bulkGenerateShifts(input);
}
